import { styled } from 'styled-components';
import { Form, H1, P } from 'ui';
import { LegacySelect } from 'ui/Select/LegacySelect.component';
import { media } from 'theme';

export const StyledH1 = styled(H1)`
  font-size: 48px;

  @media (max-width: ${media.laptop}px) {
    font-size: 36px;
  }
`;

export const StyledForm = styled(Form)`
  gap: 2.5rem;
  max-width: 30.6rem;
  width: 100%;
  padding: 7.5rem;
  box-sizing: content-box;

  @media (max-width: ${media.laptop}px) {
    padding: 0 1.25rem 0 3.75rem;
  }

  @media (max-width: ${media.tablet}px) {
    max-width: 28.25rem;
    width: 100%;
    padding: 1rem;
  }
`;

export const StyledSelect = styled(LegacySelect)`
  width: 100%;
  & > button {
    padding: 1rem 1.25rem;
    border-radius: 0.5rem;
  }
`;

export const PriceP = styled(P)`
  width: 3rem;
`;
